'use client';

import { FC } from 'react';
import CommonData from '~/data/strapi/types/single-types/common-data';

import BurgerMenu from '../burger';
import { useCallModal } from '../call-modal-provider';

interface Props {
  commonData: CommonData;
}

const StartProjectAndBurger: FC<Props> = ({ commonData }) => {
  const { openModal } = useCallModal();

  return <BurgerMenu onCallClick={openModal} commonData={commonData} />;
};

export default StartProjectAndBurger;
